module.exports = __webpack_public_path__ + "img/fish6.cb0591ea.png";